import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=ts"

import "./SvgIcon.vue?vue&type=style&index=0&id=a22939e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a22939e4"]])

export default __exports__